// LP PURCHASE TYPE
export const US_MAJOR_CITIES = 1
export const ALL_US_AREA_CODES = 2
export const ALL_CA_AREA_CODES = 4
export const ALL_GB_AREA_CODES = 5
export const ALL_US_CA_AREA_CODES = 6
export const US_ESSENTIAL_MAJOR_CITIES = 7
export const US_ALL_AREA_CODES_1000 = 8
export const US_MAJOR_CITIES_LABEL = 'US Local Presence – Major Cities'
export const ALL_US_AREA_CODES_LABEL = 'US Local Presence – Nationwide'
export const ALL_US_CA_AREA_CODES_LABEL = 'US Local Presence – California Only'
export const ALL_CA_AREA_CODES_LABEL = 'Canada Local Presence'
export const ALL_GB_AREA_CODES_LABEL = 'UK Local and Mobile'
export const US_ESSENTIAL_MAJOR_CITIES_LABEL = 'US Local Presence – Essential Major Cities'

export const LP_TYPES_LABELS = {
    1: US_MAJOR_CITIES_LABEL,
    2: ALL_US_AREA_CODES_LABEL,
    4: ALL_CA_AREA_CODES_LABEL,
    5: ALL_GB_AREA_CODES_LABEL,
    6: ALL_US_CA_AREA_CODES_LABEL,
    7: US_ESSENTIAL_MAJOR_CITIES_LABEL,
}
// LP PURCHASE STATUS
export const LP_STATUS_QUEUEING = 1
export const LP_STATUS_PURCHASING = 2
export const LP_STATUS_FINISHED = 3
export const LP_STATUS_FAILED = 4
export const LP_STATUS_DELETING = 5
export const LP_STATUS_DELETED = 6

// LP grouped by country
export const LP_TYPES_BY_COUNTRY = {
    'US': [US_MAJOR_CITIES, ALL_US_AREA_CODES, ALL_US_CA_AREA_CODES, US_ESSENTIAL_MAJOR_CITIES],
    'CA': [ALL_CA_AREA_CODES],
    'GB': [ALL_GB_AREA_CODES],
}

// LP monthly prices
export const LP_PRICES = {
    [US_MAJOR_CITIES]: 100,
    [ALL_US_AREA_CODES]: 300,
    [ALL_CA_AREA_CODES]: 100,
    [ALL_GB_AREA_CODES]: 200,
    [US_ESSENTIAL_MAJOR_CITIES]: 25
}
